/**
 * ProductOrderListContainer
 * --
 */
import React from 'react';
import ProductOrderListPresenter from './ProductOrderListPresenter';
import { useNavigate } from 'react-router-dom';
import useUpdateQuery from 'utils/useUpdateQuery';

const ProductOrderListContainer = (props) => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  // 쿼리 업데이트
  const updateQuery = useUpdateQuery();
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ProductOrderListPresenter
        navigate={navigate}
        onUpdateQuery={updateQuery}
      />
    </>
  );
};

export default ProductOrderListContainer;
